import React from "react";
import axios from "axios";
import { BASE_API_URL, DEFAULT_AXIOS_OPTIONS } from "../../../AppConstants";

export const ListMediaTypes = ({ mediaTypes, setLastChangeOccured }) => {
  const onDeleteClick = (mediaType) => () => {
    if (window.confirm(`Are you sure that you want to delete?`)) {
      axios
        .delete(
          `${BASE_API_URL}/mediaType/${mediaType.id}`,
          DEFAULT_AXIOS_OPTIONS
        )
        .then(() => {
          setLastChangeOccured(new Date());
        })
        .catch((error) => {
          console.error("error", error);
        });
    }
  };

  return (
    <>
      <h3 className="has-text-left is-size-4 mb-2">Existing Media Type</h3>
      {mediaTypes.length > 0 && (
        <table className="table is-bordered is-striped">
          <thead>
            <tr>
              {Object.keys(mediaTypes[0]).map((key) => (
                <th key={key}>{key}</th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {mediaTypes.map((mediaType) => (
              <tr key={mediaType.id}>
                {Object.values(mediaType).map((value, index) => (
                  <td key={index}>{value}</td>
                ))}
                <td>
                  <button
                    className="button is-small is-danger ml-2"
                    onClick={onDeleteClick(mediaType)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};
